export default __webpack_public_path__ + "00346db1e6dd0ea877cb23660aa8a32b.png";